// extracted by mini-css-extract-plugin
export var caretAnchor = "_ua-0";
export var dropdownContent = "_ua-1";